import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";

import { Link } from "react-router-dom";
import CityModel from "models/city.model";
import tutorsModal from "models/tutors.modal";
import enquiriesModal from "models/enquiries.modal";
import EnquiryModal from "../../../models/enquiries.modal";
import StateModel from "../../../models/states.model";

const ViewPage = () => {
  const [state, setState] = useState(null);
  const [city, setCity] = useState();
  const [gender, setGender] = useState(null);
 const [selectedCity, setSelectedCity] =useState();
  const [modal1, setModal1] = useState(false);
  const [selectedState, setSelectedState] = useState("");

  // get list of state
  const GetState = async () => {
    StateModel.listState()
      .then((responce) => {
        console.log("stateee", responce.results);
        setState(responce?.results);
        
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const handleStateChange = (e) =>{
    const value = e.target.value
    
    const find= state.find((item)=>item.name == value)
    console.log("----gg",find)
    setSelectedState(find);
  
   
  }
// Get city
const GetCity = async()=>{

 
  CityModel.getcitybyid(selectedState?.id)
  .then((response)=>{
    setCity(response)
  })
  .catch((error)=>{
    console.log("error",error)
  })
}
useEffect(()=>{
  GetCity();
},[selectedState])

  const toggleModal = () => {
    setModal1(!modal1);
  };
  const [modal2, setModal2] = useState(false);

  const toggleModal1 = () => {
    setModal2(!modal2);
  };
  const [modal3, setModal3] = useState(false);

  const toggleModal2 = () => {
    setModal3(!modal3);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [studentlist, setstudentlist] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }
  const parmas = useParams();

  
  const getListData = async () => {
    setIsLoading(true);

    await EnquiryModal.parentDetails(parmas.id)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          console.log("resultview", result);
          setDataList(result);
          setSelectedState(result?.data?.state);
          setSelectedCity(result?.data?.city)
          console.log("--------------------state ->", result?.data?.state);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
      });
  };
  // get student list

  const list = async () => {
    await enquiriesModal.parentStudentget(parmas.pid)
      .then((response) => {
        setstudentlist(response);
      })
      .catch((error) => {});
  };
  console.log("detttt=dddd",studentlist)
  useEffect(() => {
    getListData();
    list();
    GetState();
  }, [location, parmas.mid, parmas.pid]);
 
  const[finalstate, setFinalstate]=useState();
  



  const [allStudentget, setAllStudentGet] = useState("");

  const getListDataAllStudent = async () => {
    setIsLoading(true);
    await enquiriesModal
      .parentStudentget(parmas.id)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setAllStudentGet(result.data);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getListDataAllStudent();
  }, [location, parmas.id]);

  const [selectedClassType, setSelectedClassType] = useState("");

  const handleChangeClassType = (event) => {
    // Get the selected option
    const selectedOption = event.target.options[event.target.selectedIndex];
    // Update the state variables with the ID and name
    setSelectedClassType(selectedOption.value);
  };
  const item = "";

  const handleSubmiteditParentDetails = (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    //const statee = form.get("state")
   // const cities = form.get("city")

    //const selectedStateObj = state?.find((item) => item?.name.toLowerCase() === statee);
   // const selectedCityObj = city?.find((item) => item?.name.toLowerCase() === cities);

      
   // form.set("state", selectedStateObj.id)
    //form.set("city", selectedCityObj.id)
    //console.log("form state",selectedStateObj)

    // You can adjust the header configuration according to your API requirements
    enquiriesModal
      .editParentDeatils(form)
      .then((response) => {
        
        getListData();
        toggleModal();
        helper.sweetalert.toast(response.data.message, "success");
      })
      .catch((error) => {
        helper.sweetalert.toast(error?.response?.data?.name[0], "error");
      });
  };

  const [selectedGender, setSelectedGender] = useState("");

  const [selectedMode, setSelectedMode] = useState("");

  useEffect(() => {
    if (dataList?.gender) {
      setSelectedGender(dataList.gender);
      setSelectedMode(dataList.mode);
    }
  }, [dataList]);

  const handleChangegender = (event) => {
    setSelectedGender(event.target.value);
  };
  const handleChangeMode = (event) => {
    setSelectedGender(event.target.value);
  };

  const handleDel = async (id) => {
    const data = {
      id: parmas.id,
      sid: id,
    };

    helper.sweetalert
      .confirm("Are you sure you want to delete this student", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          enquiriesModal.deleteStudent(data).then((res) => {
            helper.sweetalert.toast(res.data?.message);
            getListDataAllStudent();
          });
        }
      });
  };
  console.log("rest", dataList);
  const [mode, setMode] = useState(dataList.data?.mode || "not filled");

  const handleChange = (e) => {
    setMode(e.target.value);
  };

console.log("---------rrr-----------",parmas)
  return (
    <>
      <Container className="pt-7">
        <Card className="w-100" style={{ borderRadius: ".5rem" }}>
          <CardHeader
            className="p-2 ml-3"
            style={{ color: "black", fontWeight: "bold" }}
          >
            Parent Basice Detail{" "}
          </CardHeader>
          <div className="shadow-sm" style={{ backgroundColor: "#f5f5f5" }}>
            <CardBody className="p-0 pl-4">
              <Row>
                <Col size="3">
                  {/* <div className="top-card-div"> */}
                  <div
                    style={{
                      lineHeight: "13px",
                      paddingTop: "15px",
                    }}
                  >
                    <p>
                      {" "}
                      <span style={{ color: "#999896" }}>Parent Name -</span>
                      {/* - {employeeDetails?.designation} */}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                        {`${dataList?.data?.first_name} ${dataList?.data?.last_name}`}
                      </p>
                    </p>
                  </div>
                  {/* </div> */}
                </Col>
                <Col size="3">
                  <div
                    style={{
                      lineHeight: "13px",
                      paddingTop: "15px",
                    }}
                  >
                    <p>
                      <span style={{ color: "#999896" }}>Mobile no -</span>{" "}
                      {/* - {employeeDetails?.roleName} */}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                        {dataList?.data?.mobile}
                      </p>
                    </p>
                  </div>
                </Col>
                <Col size="3">
                  <div
                    style={{
                      lineHeight: "13px",
                      paddingTop: "15px",
                    }}
                  >
                    <p>
                      <span style={{ color: "#999896" }}>Gender -</span>{" "}
                      {/* - {employeeDetails?.roleName} */}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                        {" "}
                        {dataList?.data?.gender}
                      </p>
                    </p>
                  </div>
                </Col>
                <Col size="3">
                  <div
                    style={{
                      lineHeight: "13px",
                      paddingTop: "15px",
                    }}
                  >
                    <p className="card-text">
                      <span style={{ color: "#999896" }}>Email Address -</span>{" "}
                      <br />{" "}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                        {dataList?.data?.email}
                      </p>
                      {/* {employeeDetails?.parent_department_name}{" "} */}
                    </p>
                  </div>
                </Col>
              </Row>

              <hr className="mt-0 mb-4" />
              <Row>
                <Col size="3">
                  <div className="top-card-div">
                    <p className="card-text">
                      <span style={{ color: "#999896" }}>
                        Mode of Tuition -
                      </span>{" "}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                        {dataList?.data?.mode}
                      </p>
                      {/* {moment(Emphist?.joining_date).format(
                                  "DD/MM/YYYY"
                                )} */}
                    </p>
                  </div>
                </Col>
                <Col size="3">
                  <div className="top-card-div">
                    <p className="card-text">
                      <span style={{ color: "#999896" }}>Location -</span>{" "}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                        {dataList?.data?.location}
                      </p>
                      {/* {moment(Emphist?.joining_date).format(
                                  "DD/MM/YYYY"
                                )} */}
                    </p>
                  </div>
                </Col>
                <Col size="3">
                  <div className="top-card-div">
                    <p className="card-text">
                      <span style={{ color: "#999896" }}>State -</span> <br />{" "}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                        {" "}
                        {dataList?.data?.state}
                      </p>
                      {/* {employeeDetails?.parent_department_name}{" "} */}
                    </p>
                  </div>
                </Col>
                <Col size="3">
                  <div className="top-card-div">
                    <p className="card-text">
                      <span style={{ color: "#999896" }}>City -</span>{" "}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                        {dataList?.data?.city}
                      </p>
                      {/* {moment(Emphist?.joining_date).format(
                                  "DD/MM/YYYY"
                                )} */}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className="mt-0" />
            </CardBody>
            <Row className="mb-2">
              <Col md={12}>
                <Button
                  type="submit"
                  // style={{ float: "right", marginTop: "20px" }}
                  onClick={toggleModal}
                  style={{
                    backgroundColor: "#080278",
                    color: "white",
                    border: "none",
                    float: "right",
                    marginRight: "20px",
                  }}
                >
                  Edit
                </Button>
              </Col>
            </Row>
          </div>
        </Card>
        {true && (
          <Row>
            <div className="col mt-3">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between ">
                  <h3 className="mb-0">Students List</h3>
                </CardHeader>

                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">S.No.</th>
                      <th scope="col">Student NAME</th>
                      <th scope="col">Academic</th>
                      <th scope="col">Board</th>
                      <th scope="col">Class</th>
                      <th scope="col">Subject</th>

                      <th scope="col">Gender</th>
                      <th scope="col">Date of Birth</th>
                      <th scope="col"> School/College/University Name</th>
                      <th scope="col">Preferred Time Duration</th>
                      <th scope="col">Tuition Tenure</th>
                      <th scope="col">Location Preference</th>
                      {/* <th scope="col"> Enquiry For</th> */}
                      <th scope="col"> Loaction City</th>
                      <th scope="col"> Tutors Level</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>

                  {true && (
                    <tbody>
                      {studentlist?.data?.length > 0 ? (
                        studentlist?.data?.map((item, index) => {
                          console.log("ttttttttt999",item)
                          return (
                            <tr key={item.id} style={{ cursor: "pointer" }}>
                              <td>{index + 1}</td>
                              <td>{item?.name || "-"}</td>
                              <td>{item?.Academic || "-"}</td>
                              <td>{item?.Board || "-"}</td>
                              <td>{item?.Class || "-"}</td>
                              <td>
                                {item?.subjects?.map((item) => item) || "-"}
                              </td>
                              <td>{item?.gender || "-"}</td>
                              <td> {item?.dob || "-"}</td>
                              <td>{item?.school_name || "-"}</td>
                              <td>{item?.preferrd_time || "-"}</td>
                              <td>{item?.term || "-"}</td>
                              <td>{item?.location || "-"}</td>
                              {/* <td  >{item?.Enquiry_For || "Student"}</td> */}
                              <td>{item?.city || "-"}</td>
                              <td>{item?.tutor_level || "-"}</td>
                              <td
                                className="pl-4 p-0"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  // justifyContent: "center",
                                  // alignItems: "center",
                                }}
                              >
                                <UncontrolledTooltip
                                  placement="bottom"
                                  target="eyeTooltips"
                                >
                                  Edit
                                </UncontrolledTooltip>
                                <Link
                                  id="eyeTooltips"
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "blue",
                                    // backgroundColor: "#f5f5f5",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "30%", // Optional: Make it a circle
                                  }}
                                  tag={Link}
                                  to={`/admin/viewenquiry/EditEnquriParentDetails/${parmas.pid}/${parmas.id}/${item.id}`}
                                >
                                  <i className="fa-solid fa-pen-to-square"></i>
                                </Link>
{/* 
                                <UncontrolledTooltip
                                  placement="bottom"
                                  target="userTooltip"
                                >
                                  Delete
                                </UncontrolledTooltip>
                                <p
                                  style={{
                                    margin: "0 8px",
                                    fontSize: "15px",
                                    color: "red",
                                    marginTop: "10px",
                                    // backgroundColor: "#f5f5f5",
                                    display: "inline-block",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "20%", // Optional: Make it a circle
                                  }}
                                  id="userTooltip"
                                  onClick={() => handleDel(item.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </p>*/}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr style={{ textAlign: "center" }}>
                          <td colSpan="6" style={{ verticalAlign: "middle" }}>
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </Table>
              </Card>
            </div>
          </Row>
        )}

        <Modal isOpen={modal1} toggle={toggleModal} size="lg">
          <ModalHeader toggle={toggleModal}>
            <h4> Edit Parent Details</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmiteditParentDetails}>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Parent Name </Label>
                    <Input
                      type="text"
                      placeholder="Enter Name"
                      name="first_name"
                      defaultValue={dataList?.data?.first_name}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Parent Last Name</Label>
                    <Input
                      type="text"
                      placeholder="Enter Last Name"
                      name="last_name"
                      defaultValue={dataList?.data?.last_name}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Email Address</Label>
                    <Input
                      type="text"
                      placeholder="Enter Email Address"
                      name="email"
                      defaultValue={dataList?.data?.email}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Mobile no</Label>
                    <Input
                    name="mobile"
                      type="text"
                      placeholder="Enter Mobile no"
                      readOnly
                      defaultValue={dataList?.data?.mobile}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Gender</Label>
                    <Input
                     
                      type="select"
                      name="gender"
                      defaultValue={dataList.data?.gender}
                     // onChange={(e) => {
                        //setGender(e.target.value);}}
                    >
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Mode of Tuition</Label>

                    <Input
                      id="forType"
                      name="modeOfTution"
                      type="select"
                      defaultValue={dataList?.data?.mode || "not filled"}
                      //onChange={(e) => {
                       // setMode(e.target.value);}}
                    ><option value="">select</option>
                      <option value="Online">Online</option>
                      <option value="Offline">Offline</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">State</Label>
                    <Input
                      id="forstate"
                      name="state"
                      type="select"
                      defaultValue={dataList?.data?.state}
                     onChange={handleStateChange}
                     
                    >
                      
                      {state?.map((item, key) => {
                        return (
                          <option key={key}
                            value={item?.name}
                          >
                            {item?.name}
                          </option>
                        );
                      })}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Loaction</Label>
                    <Input
                      type="text"
                      placeholder="Enter Loaction"
                      name="location"
                      defaultValue={dataList?.data?.location || "not filled"}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">City</Label>
                    {!city &&
                    <Input
                    readOnly
                      name="city"
                      type="text"
                      defaultValue={dataList?.data?.city || "not filled"}
                    ></Input>}
                    {city &&
                    <Input
                    
                      name="city"
                      type="select"
                      
                    >
                     
                      {city?.map((item, index)=>{
                        return(
                          <option value={item.value}>{item?.name}</option>)
                      })}
                     
                     
                    </Input>}
                  </FormGroup>
                </Col>
              </Row>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal}>
                  Cancel
                </Button>
                {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                <Button
                  color="primary"
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                  }}

                  // onClick={}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal2} toggle={toggleModal1}>
          <ModalHeader toggle={toggleModal1}>
            <h4>Enquiry Pending </h4>
          </ModalHeader>
          <ModalBody>
            <Input type="textarea" placeholder="Enter Reason" />
            <Input type="date" className="mt-3" />
            <Input type="time" className="mt-3" />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal1}>
                Cancelget
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                }}
                // onClick={}
              >
                Save
              </Button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal3} toggle={toggleModal2}>
          <ModalHeader toggle={toggleModal2}>
            <h4> Enquiry Disqualify</h4>
          </ModalHeader>
          <ModalBody>
            <Input type="textarea" placeholder="Enter Reason" />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal2}>
                Cancel
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    </>
  );
};

export default ViewPage;
